import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
		<div id="timeline-to-scroll"></div>
		<div className="space-between-sections"></div>
      <div className="items-container">
        {document.getElementById('portal')?.classList.contains('light-mode') && 
			<h1 className="big-h1">История <span className="green-text-light">карьеры</span></h1>
		}
		{!document.getElementById('portal')?.classList.contains('light-mode') && 
			<h1 className="big-h1">История <span className="green-text">карьеры</span></h1>
		}
		<div className="horizontal-line margin-bottomDIV"></div>
        <VerticalTimeline>
			{document.getElementById('portal')?.classList.contains('light-mode') && 
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'white', color: 'rgb(0, 0, 0)' }}
					contentArrowStyle={{ borderRight: '7px solid  white' }}
					date="2024 - н.в."
					iconStyle={{ background: '#24817B', color: 'rgb(0, 0, 0)' }}
					icon={<FontAwesomeIcon icon={faBriefcase} />}
				>
					<h3 className="vertical-timeline-element-title">Комьюнити-менеджер</h3>
					<h4 className="vertical-timeline-element-subtitle">Совет обучающихся ШКН ТюмГУ</h4>
					<p>
						Третий год вхожу в президиум Совета обучающихся своего института.
					</p>
					<p>
						Меня ценят как ответственного менеджера, понимающего значение системности в работе.
					</p>
					<p>
						Выстраиваю системные процессы сообщества, развиваю коммуникацию, формирую вектор развития.
					</p>
				</VerticalTimelineElement>
			}
			{!document.getElementById('portal')?.classList.contains('light-mode') && 
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'white', color: 'rgb(0, 0, 0)' }}
					contentArrowStyle={{ borderRight: '7px solid  white' }}
					date="2024 - н.в."
					iconStyle={{ background: '#008b23', color: 'rgb(0, 0, 0)' }}
					icon={<FontAwesomeIcon icon={faBriefcase} />}
				>
					<h3 className="vertical-timeline-element-title">Комьюнити-менеджер</h3>
					<h4 className="vertical-timeline-element-subtitle">Совет обучающихся ШКН ТюмГУ</h4>
					<p>
						Третий год вхожу в президиум Совета обучающихся своего института.
					</p>
					<p>
						Меня ценят как ответственного менеджера, понимающего значение системности в работе.
					</p>
					<p>
						Выстраиваю системные процессы сообщества, развиваю коммуникацию, формирую вектор развития.
					</p>
				</VerticalTimelineElement>
			}

          {document.getElementById('portal')?.classList.contains('light-mode') && 
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'white', color: 'rgb(0, 0, 0)' }}
					contentArrowStyle={{ borderRight: '7px solid  white' }}
					date="2023 - н.в."
					iconStyle={{ background: '#24817B', color: 'rgb(0, 0, 0)' }}
					icon={<FontAwesomeIcon icon={faBriefcase} />}
				>
					<h3 className="vertical-timeline-element-title">Проектный менеджер</h3>
					<h4 className="vertical-timeline-element-subtitle">Совет обучающихся ШКН ТюмГУ</h4>
					<p>
						Организую мероприятия. На крупных проектах главный организатор. Мне доверяют сотни участников,
						потому что знают, что я сделаю отлично.
					</p>
					<p>
						Под ключ пишу грантовые заявки, защищаю их и выигрываю сотни тысяч рублей для сообщества.
					</p>
					<p>
						Курирую медиа-проекты.
					</p>
				</VerticalTimelineElement>
			}
			{!document.getElementById('portal')?.classList.contains('light-mode') && 
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'white', color: 'rgb(0, 0, 0)' }}
					contentArrowStyle={{ borderRight: '7px solid  white' }}
					date="2023 - н.в."
					iconStyle={{ background: '#008b23', color: 'rgb(0, 0, 0)' }}
					icon={<FontAwesomeIcon icon={faBriefcase} />}
				>
					<h3 className="vertical-timeline-element-title">Проектный менеджер</h3>
					<h4 className="vertical-timeline-element-subtitle">Совет обучающихся ШКН ТюмГУ</h4>
					<p>
						Организую мероприятия. На крупных проектах главный организатор. Мне доверяют сотни участников,
						потому что знают, что я сделаю отлично.
					</p>
					<p>
						Под ключ пишу грантовые заявки, защищаю их и выигрываю сотни тысяч рублей для сообщества.
					</p>
					<p>
						Курирую медиа-проекты.
					</p>
				</VerticalTimelineElement>
			}

			{document.getElementById('portal')?.classList.contains('light-mode') && 
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'white', color: 'rgb(0, 0, 0)' }}
					contentArrowStyle={{ borderRight: '7px solid  white' }}
					date="2021 - 2023"
					iconStyle={{ background: '#24817B', color: 'rgb(0, 0, 0)' }}
					icon={<FontAwesomeIcon icon={faBriefcase} />}
				>
					<h3 className="vertical-timeline-element-title">Комьюнити-менеджер</h3>
					<h4 className="vertical-timeline-element-subtitle">Официальный Discord-сервер Unity Engine</h4>
					<p>
						Администрировал интернациональное сообщество из 100 тысяч участников.
					</p>
					<p>
						Организовывал и курировал онлайн-собрания, модерировал чаты.
					</p>
				</VerticalTimelineElement>
			}
			{!document.getElementById('portal')?.classList.contains('light-mode') && 
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'white', color: 'rgb(0, 0, 0)' }}
					contentArrowStyle={{ borderRight: '7px solid  white' }}
					date="2021 - 2023"
					iconStyle={{ background: '#008b23', color: 'rgb(0, 0, 0)' }}
					icon={<FontAwesomeIcon icon={faBriefcase} />}
				>
					<h3 className="vertical-timeline-element-title">Комьюнити-менеджер</h3>
					<h4 className="vertical-timeline-element-subtitle">Официальный Discord-сервер Unity Engine</h4>
					<p>
						Администрировал интернациональное сообщество из 100 тысяч участников.
					</p>
					<p>
						Организовывал и курировал онлайн-собрания, модерировал чаты.
					</p>
				</VerticalTimelineElement>
			}

			{document.getElementById('portal')?.classList.contains('light-mode') && 
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'white', color: 'rgb(0, 0, 0)' }}
					contentArrowStyle={{ borderRight: '7px solid  white' }}
					date="2019 - 2021"
					iconStyle={{ background: '#24817B', color: 'rgb(0, 0, 0)' }}
					icon={<FontAwesomeIcon icon={faBriefcase} />}
				>
					<h3 className="vertical-timeline-element-title">Мастер по ремонту компьютеров</h3>
					<h4 className="vertical-timeline-element-subtitle">Самозанятость</h4>
					<p>
						Сам искал клиентов. Работал по вызову на адресе клиента.
					</p>
				</VerticalTimelineElement>
			}
			{!document.getElementById('portal')?.classList.contains('light-mode') && 
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'white', color: 'rgb(0, 0, 0)' }}
					contentArrowStyle={{ borderRight: '7px solid  white' }}
					date="2019 - 2021"
					iconStyle={{ background: '#008b23', color: 'rgb(0, 0, 0)' }}
					icon={<FontAwesomeIcon icon={faBriefcase} />}
				>
					<h3 className="vertical-timeline-element-title">Мастер по ремонту компьютеров</h3>
					<h4 className="vertical-timeline-element-subtitle">Самозанятость</h4>
					<p>
						Сам искал клиентов. Работал по вызову на адресе клиента.
					</p>
				</VerticalTimelineElement>
			}

			
        </VerticalTimeline>
      </div>
	  <div className="space-between-sections"></div>
    </div>
  );
}

export default Timeline;